import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { getAfterSchoolLecture } from '../../../redux/actions/adminActions';
import dayjs from 'dayjs';
import CustomTableSortable from '../table/CustomTableSortable';

export default function AdminVideoLogs({ logOpen, setLogOpen, dispatch, videoTypeLogs, lecInfo, afterSchoolLectures }) {
    const handleClose = () => {
        setLogOpen(false);
    };

    useEffect(() => {
        if (lecInfo) {
            dispatch(getAfterSchoolLecture(lecInfo.id));
        }
    }, [dispatch, lecInfo]);

    const rows = afterSchoolLectures?.map((r) => {
        const matched = videoTypeLogs.filter((v) => v.url === r.url && v?.afterschoolId === lecInfo?.afterSchoolId)[0];
        return {
            ...r,
            status: matched?.status === 'done' ? '완료' : matched?.status === 'ing' ? '수강중' : '미수강',
            createdAt: matched?.createdAt ? dayjs(matched?.createdAt * 1000).format('YYYY-MM-DD HH:mm') : '',
            changedAt: matched?.changedAt ? dayjs(matched?.changedAt * 1000).format('YYYY-MM-DD HH:mm') : '',
        };
    });

    const dones = rows?.filter((r) => r?.status === '완료');

    return (
        <Dialog open={logOpen} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>수강자 학습 진도</DialogTitle>
            <DialogContent>
                <Typography gutterBottom style={{ fontWeight: '500' }}>{`수강진도 : ${dones?.length}개 / ${
                    rows?.length
                }개 (${Math.round((dones?.length / rows?.length) * 100)}%)`}</Typography>
                <CustomTableSortable
                    {...{
                        headCells,
                        rows,
                        defaultOrderBy: 'createdAt',
                        desc: 'asc',
                        width: '300px',
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>닫기</Button>
            </DialogActions>
        </Dialog>
    );
}

const headCells = [
    { id: 'no', align: 'center', disablePadding: true, label: 'no.' }, //
    { id: 'title', align: 'center', disablePadding: false, label: '타이틀' },
    { id: 'status', align: 'center', disablePadding: true, label: '수강상태' },
    { id: 'createdAt', align: 'center', disablePadding: true, label: '시작일' },
    { id: 'changedAt', align: 'center', disablePadding: true, label: '수정일' },
];
